/**
 * Import all Route components
 */
import ErrorPage from '@components/ErrorPage/loadable';
import NotFound from '@components/NotFound';
import Home from '@containers/Home/loadable';
import ProductDetail from '@containers/ProductDetailContainer/loadable';
import ReviewsPage from '@containers/ReviewsPage/loadable';
import WishList from '@containers/WishList/loadable';
import WishlistLists from '@containers/WishlistLists';

/**
 * create dictionary of all loadable components
 */
const loadables = {
  Home,
  ProductDetail,
  ErrorPage,
  NotFound,
  WishList,
  WishlistLists,
  ReviewsPage,
};

export default loadables;
